import { Component, ComponentRef, OnInit, TemplateRef, ViewChild, ViewContainerRef } from "@angular/core";
import { PageCloseButtonComponent } from "../../../common/close-button/page-close-button.component";
import { ActivatedRoute, Router } from "@angular/router";
import { DynamicFormComponent } from "../../../dynamic-form/dynamic-form.component";
import { DynamicForm } from "../../../../models/dynamic-form";
import CustomerAgreementFormConfig from "../config/CustomerAgreementFormConfig.json";
import AgreementConfigurationListingConfig from "../config/AgreementConfiguartionListing.config.json";
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { DynamicFormService } from "../../../../services/dynamic-form.service";
import { FileUploadComponent } from "../../../file-upload/file-upload.component";
import { NoDataComponent } from "../../../no-data/no-data.component";
import { NgClass, NgIf } from "@angular/common";
import { SvgIconComponent } from "../../../svg-icon/svg-icon.component";
import { AgreementConfigurationDTO, CustomerAgreementInterface } from "../../../../models/customer-agreement.interface";
import { FinanceApiService } from "../../../../services/finance-a-p-iervice.service";
import { LoadingService } from "../../../../services/loading.service";
import { ToasterService } from "../../../../services/toaster.service";
import { StaticTableComponent } from "../../../static-table/static-table.component";
import { TableMeta } from "../../../../models/table-meta.interface";
import { DeterminantDetails } from "../../../../models/determinant-details";
import { forkJoin } from "rxjs";
import { TariffService } from "../../../../services/tariff.service";
import { Rule } from "../../../../models/tariff-rule-set";
import {
  AGREEMENT_CONFIGURATION_ACTIONS
} from "./manage-agreement-configuration/manage-agreement-configuration.component";
import { FileSource, FileUploadService } from "../../../../services/file-upload.service";
import { ModalComponent } from "../../../modal/modal.component";
import { AddAnotherDialogComponent } from "../../../add-another-dialog/add-another-dialog.component";
import { SkeletonLoaderComponent } from "../../../skeleton-loader/skeleton-loader.component";
import customerAgreementFormConfig from "../config/CustomerAgreementFormConfig.json";
import { ConfirmDialogV2Component } from "../../../confirm-dialog/confirm-dialog-v2.component";
import { CommonUtils } from "../../../../utils/common-utils";
import { FileEntity } from "../../../../models/common-model.interface";
import { DeterminantType } from "../../../../constants/finance-constants";

export const CUSTOMER_AGREEMENT_ACTIONS = {
  ADD_NEW: "add-new",
  EDIT: "edit",
  VIEW: "view",
  CONFIGURATIONS: "configurations"
} as const;
export type urlActionType = typeof CUSTOMER_AGREEMENT_ACTIONS[keyof typeof CUSTOMER_AGREEMENT_ACTIONS];

@Component({
  selector: "app-manage-customer-agreement",
  standalone: true,
  imports: [
    PageCloseButtonComponent,
    DynamicFormComponent,
    FileUploadComponent,
    NoDataComponent,
    SvgIconComponent,
    NgIf,
    StaticTableComponent,
    NgClass,
    SkeletonLoaderComponent,
    ReactiveFormsModule
  ],
  templateUrl: "./manage-customer-agreement.component.html",
  styleUrl: "./manage-customer-agreement.component.scss"
})
export class ManageCustomerAgreementComponent implements OnInit {
  private _customerAgreementEditEnabled: boolean = false;
  private _configurationsEditEnabled: boolean = false;
  private _customerAgreementData!: CustomerAgreementInterface;

  customerAgreementFormConfig: DynamicForm = CustomerAgreementFormConfig;
  agreementConfigurationListingConfig: TableMeta = AgreementConfigurationListingConfig;
  customerAgreementForm: FormGroup;
  validActions: urlActionType[] = Object.values(CUSTOMER_AGREEMENT_ACTIONS);
  currentAction: string = CUSTOMER_AGREEMENT_ACTIONS.VIEW;
  currentAgreementId: string = "";
  allDeterminants: DeterminantDetails[] = [];
  selectedFiles: FileEntity[] = [];
  isLoading: boolean = false
  cloneAgreementForm!: FormGroup;

  componentRef!: ComponentRef<ModalComponent>;

  @ViewChild("cloneAgreementConfigForm") cloneAgreementConfigForm!: TemplateRef<any>;


  constructor(private router: Router,
              private route: ActivatedRoute,
              private fb: FormBuilder,
              private dynamicFormService: DynamicFormService,
              private financeApiService: FinanceApiService,
              private loadingService: LoadingService,
              private toasterService: ToasterService,
              private tariffService: TariffService,
              private fileUploadService: FileUploadService,
              private viewContainerRef: ViewContainerRef) {
    this.customerAgreementForm = this.fb.group({});
    this.cloneAgreementForm = this.fb.group({
      description: ['']
    })
  }

  get customerAgreementEditEnabled(): boolean {
    return this._customerAgreementEditEnabled;
  }

  set customerAgreementEditEnabled(value: boolean) {
    if (!value) {
      this.customerAgreementForm.disable();
    }
    this._customerAgreementEditEnabled = value;
  }

  get configurationsEditEnabled(): boolean {
    return this._configurationsEditEnabled;
  }

  set configurationsEditEnabled(value: boolean) {
    this._configurationsEditEnabled = value;
  }

  get customerAgreementData(): CustomerAgreementInterface {
    return this._customerAgreementData;
  }

  set customerAgreementData(value: CustomerAgreementInterface) {
    if (!value) return;

    value.agreementConfigurations?.forEach((agreementConfiguration) => {
      if (agreementConfiguration.criteria?.rules) {
        agreementConfiguration.criteria.rules = agreementConfiguration.criteria.rules?.map((rule: any) => {
          return this.convertRuleToDisplayText(rule);
        });
      }
    });

    this._customerAgreementData = value;
  }


  ngOnInit(): void {
    this.initializeComponent();
    this.loadingService.loading$.subscribe({
      next: loading => {
        this.isLoading = loading.isLoading
      }
    })
  }

  goBack() {
    this.router.navigateByUrl("/manage-finance/customer-agreement");
  }

  private initializeComponent() {
    this.dynamicFormService.addControlsToForm(this.customerAgreementForm, this.customerAgreementFormConfig);
    this.setUpAppMode();
  }

  async save() {
    this.customerAgreementForm.markAllAsTouched();
    if (this.customerAgreementForm.invalid) {
      return;
    }

    const fileUploadIds = await this.uploadFiles();

    const customerAgreementDto = this.prepareCustomerAgreementDto();
    customerAgreementDto.fileUploads = fileUploadIds.map((id) => {
      return {
        id
      };
    });

    if (this.currentAction === CUSTOMER_AGREEMENT_ACTIONS.ADD_NEW) {
      this.callApiToAddNewAgreement(customerAgreementDto);
    } else if (this.currentAction === CUSTOMER_AGREEMENT_ACTIONS.EDIT) {
      this.callApiToEditAgreement(this.currentAgreementId, customerAgreementDto);
    }

  }

  private prepareCustomerAgreementDto() {
    const customerAgreementDto: CustomerAgreementInterface = {
      ...this.customerAgreementForm.value,
      accountHolder: this.customerAgreementForm.get("accountHolder")?.value?.key
    };

    return customerAgreementDto;
  }

  private callApiToAddNewAgreement(customerAgreementDto: CustomerAgreementInterface) {
    this.financeApiService.createCustomerAgreement(customerAgreementDto).subscribe({
      next: (res) => {
        const data: CustomerAgreementInterface = res.data;
        this.showAddAddConfigurationsDialog(data);
        this.toasterService.success("Customer Agreement Created Successfully");
      },
      error: (err) => {
        this.toasterService.error(err.error.message);
      }
    });
  }

  private setUpAppMode() {
    const rawPath = this.route.snapshot.url[0]?.path;
    this.currentAction = this.validActions.includes(rawPath as urlActionType) ? (rawPath as urlActionType) : CUSTOMER_AGREEMENT_ACTIONS.CONFIGURATIONS;
    switch (this.currentAction) {
      case CUSTOMER_AGREEMENT_ACTIONS.ADD_NEW:
        this.customerAgreementEditEnabled = true;
        this.configurationsEditEnabled = false;
        break;
      case CUSTOMER_AGREEMENT_ACTIONS.EDIT:
        this.customerAgreementEditEnabled = true;
        this.configurationsEditEnabled = false;
        this.setUpAppForEditAndViewMode();
        break;
      case CUSTOMER_AGREEMENT_ACTIONS.VIEW:
        this.customerAgreementEditEnabled = false;
        this.configurationsEditEnabled = false;
        this.setUpAppForEditAndViewMode();
        break;
      case CUSTOMER_AGREEMENT_ACTIONS.CONFIGURATIONS:
        this.customerAgreementEditEnabled = false;
        this.configurationsEditEnabled = true;
        this.setUpAppForEditAndViewMode();
        break;
      default:
        this.customerAgreementEditEnabled = false;
        this.configurationsEditEnabled = false;
        break;
    }
  }

  private setUpAppForEditAndViewMode() {
    this.currentAgreementId = this.route.snapshot.params["agreementId"] || "";
    this.loadingService.show('inline')
    forkJoin({
      determinants: this.financeApiService.getDeterminantDetails(DeterminantType.TARIFF),
      agreement: this.financeApiService.getCustomerAgreement(this.currentAgreementId)
    }).subscribe({
      next: ({ determinants, agreement }) => {
        // Set determinants
        this.allDeterminants = determinants.data;

        // Set agreement data
        this.customerAgreementData = agreement.data;
        const data: CustomerAgreementInterface = this.customerAgreementData;
        this.customerAgreementForm.patchValue({
          ...data,
          accountHolder: {
            key: data.accountHolder.id,
            value: data.accountHolder.name
          }
        });
        this.selectedFiles = this.fileUploadService.convertToFileFromFileUploadDto(data.fileUploads);
        this.loadingService.hide()
      },
      error: (err) => {
        this.router.navigateByUrl(`/manage-finance/customer-agreement/${CUSTOMER_AGREEMENT_ACTIONS.ADD_NEW}`);
        this.toasterService.error(err?.error?.errorDesc || "An error occurred");
        this.loadingService.hide()
      }
    });
  }

  private callApiToEditAgreement(currentAgreementId: string, customerAgreementDto: CustomerAgreementInterface) {
    this.financeApiService.updateCustomerAgreement(currentAgreementId, customerAgreementDto).subscribe({
      next: (res) => {
        const data: CustomerAgreementInterface = res.data;
        this.showAddAddConfigurationsDialog(data);
        this.toasterService.success("Customer Agreement Updated Successfully");
      },
      error: (err) => {
        this.toasterService.error(err.error.message);
      }
    });
  }

  createNewAgreementConfiguration() {
    this.router.navigate([`add-new`], { relativeTo: this.route });
  }

  private convertRuleToDisplayText(rule: Rule) {
    const determinantText = this.tariffService.getDisplayTextForDeterminant(rule.determinant, this.allDeterminants);
    const operatorText = this.tariffService.getDisplayTextForOperator(rule.operator);
    const valuesText = this.tariffService.getValuesToPrint(rule);

    return `${determinantText} ${operatorText} ${valuesText}`;
  }

  handleRowAction(event: any) {
    console.log(event);
    const action = event.actionName;
    switch (action) {
      case AGREEMENT_CONFIGURATION_ACTIONS.CONFIGURE_AGREEMENT:
        this.router.navigate([`configure/${event.record.id}`], { relativeTo: this.route });
        break;
      case AGREEMENT_CONFIGURATION_ACTIONS.EDIT_AGREEMENT_CONFIGURATION:
        this.router.navigate([`edit/${event.record.id}`], { relativeTo: this.route });
        break;
      case AGREEMENT_CONFIGURATION_ACTIONS.VIEW_AGREEMENT_CONFIGURATION:
        this.router.navigate([`delete/${event.record.id}`], { relativeTo: this.route });
        break;
      case AGREEMENT_CONFIGURATION_ACTIONS.DELETE_AGREEMENT_CONFIGURATION:
        this.deleteAgreementConfiguration(event.record);
        break;
      case AGREEMENT_CONFIGURATION_ACTIONS.CLONE_AGREEMENT_CONFIGURATION:
        this.createCloneAgreementConfigurationModal(event.record);
        break;
      default:
        console.error(`Invalid action: ${action}`);
        break;
    }

  }


  async uploadFiles(): Promise<string[]> {
    const uploadedFileIds: string[] = [];
    const formDataArray = this.fileUploadService.createFormDataToSend(
      this.selectedFiles.map(fe => fe.file),
      FileSource.CUSTOMER_AGREEMENT
    );

    try {
      if (formDataArray.length > 0) {
        await this.fileUploadService.uploadFilesSequentially(formDataArray, uploadedFileIds);
      }
      return uploadedFileIds;
    } catch (error) {
      console.error("File upload failed:", error);
      throw error;
    }
  }

  private showAddAddConfigurationsDialog(data: CustomerAgreementInterface) {
    const updateText = this.currentAction === CUSTOMER_AGREEMENT_ACTIONS.EDIT ? "Updated" : "Created";
    const modalRef = this.viewContainerRef.createComponent(ModalComponent);
    const filterDialogRef = modalRef.instance.loadComponent(
      AddAnotherDialogComponent,
      {
        featureIconPath: "assets/icons/tick_add_another_dialog.svg",
        title: `Customer Agreement ${updateText} Successfully.`,
        titleDescription: `The Customer Agreement has been successfully ${updateText}. Click “Configure Agreement" to create/edit the Configurations.`,
        primaryBtnText: "Configure Agreement",
        primaryBtnUrl: `/manage-finance/customer-agreement/${data.id}/${CUSTOMER_AGREEMENT_ACTIONS.CONFIGURATIONS}`,
        secondaryBtnUrl: "/manage-finance/customer-agreement"
      }
    );

    modalRef.instance.close.subscribe(() => modalRef.destroy());
  }


  private deleteAgreementConfiguration(record: any) {

  }

  private createCloneAgreementConfigurationModal(record: AgreementConfigurationDTO) {
    const componentRef = this.viewContainerRef.createComponent(ModalComponent);
    componentRef.instance.title = "Clone Agreement Configuration";
    componentRef.instance.width = "600px";
    this.componentRef = componentRef; //saving reference in global variable

    this.cloneAgreementForm.patchValue({
      description: `${record.description ?? "N/A"} - Clone`,
    })


    const loadComponent = componentRef.instance.loadComponent(this.cloneAgreementConfigForm,{
      record: {...record,...this.cloneAgreementForm.value}
    });

    componentRef.instance.close.subscribe(() => componentRef.destroy());
  }

  cloneAgreementConfiguration(record: AgreementConfigurationDTO) {
    if(!CommonUtils.isNotNil(record?.id)){
      console.log(record.id + "not found");
      return;
    }
    delete record.criteria;

    this.loadingService.show()
    this.financeApiService.cloneCustomerAgreementConfiguration(this.currentAgreementId,record.id ?? "",record).subscribe({
      next: (res: any) => {
        console.log(res.data);
        this.loadingService.hide();
        this.toasterService.success("Agreement Configuration cloned successfully.");
        this.componentRef.destroy();
        //refresh parent here
        this.setUpAppForEditAndViewMode();
      },
      error: (err: any) => {
        console.log(err);
        this.loadingService.hide();
        this.toasterService.error(err.error.errorDesc);
      }
    });
  }
}
